import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import AdministratorsContent from './AdministratorsContent'
export default class Administrators extends Component {

   

    render() {
        let page = this.props.match.params.page;
        return (
            <div class="wrapper">

                <Navbar />
                <Mainmenu />
                <AdministratorsContent page={page} />
                <Footer />

            </div>


        )
    }
}
